export default "__VITE_ASSET__a62d248a__"